import { Cookies } from 'react-cookie';

export const handleChangeShop = async (shopId, isAllShops, setLoggedInUser, initPage) => {
  const cookies = new Cookies();
  const expireDate = new Date();
  expireDate.setYear(expireDate.getFullYear() + 1);
  cookies.set('shopIdSelected', shopId, { expires: expireDate, path: '/' });
  cookies.set('isAllShops', isAllShops, { expires: expireDate, path: '/' });
  initPage();
  await setLoggedInUser(shopId, isAllShops, true);
};
